export enum HTMLFile {
    Popup = 'popup',
    Main = 'main',
}